import { UserAttributeState } from '../admin/types/group-user-attribute.types';

export const userAttributeGetters = {
  isMissingAttributeValue: (state: UserAttributeState) =>
    state.isMissingAttributeValue
};
